class AppHeaderController {
  constructor($state, SsoAuthorizationService, config) {
    this.name = 'appHeader';
    this.$state = $state;
    this.config = config;
    this.ssoService = SsoAuthorizationService;
  }

  isAuthRequired() {
    return this.$state.current.authRequired;
  }

  isSso() {
    return this.ssoService.getSsoLaunch();
  }

  parseUrl(url){
    return url.replace(/^(https?:|)\/\//, '');
  }
}

AppHeaderController.$inject = ['$state', 'SsoAuthorizationService', 'config'];

export default AppHeaderController;



// WEBPACK FOOTER //
// ./app/common/appHeader/appHeader.controller.js